
























import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'business-year-select',
  components: {
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CheckSquareIcon,
    CheckIcon,
  },
})
export default class BusinessYearSelect extends mixins(BaseMixin, FilterMixin) {
  @Prop({ type: Object })
  selected!: Date;

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  @Prop({ type: Boolean, default: () => false })
  hideIcon!: boolean;

  @Prop({ type: Boolean, default: () => false })
  hideReset!: boolean;

  changed(val: number) {
    this.$emit('update', val);
  }

  reset() {
    this.$emit('update', new Date().getFullYear());
  }
  get yearOptions() {
    const startYear = new Date(this.agency.createdAt).getFullYear();
    const currentYear = new Date().getFullYear();
    // create array with years from startYear to currentYear
    const years = Array.from(
      { length: currentYear + 2 - startYear + 2 },
      (_, i) => startYear + i,
    ).reverse();

    return years.map((year) => new Date(year, 0, 1, 10, 0, 0, 0));
  }

  labelYear(date: Date) {
    return `${new Date(date).getFullYear()}`;
  }
}
